/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.academics.course-groups'},
});

const CourseGroupsItem = () => (
  <RouteLinkItem
    route="midas/settings/academics/course-groups"
    title={messages.title}
  />
);

export default CourseGroupsItem;
